module.exports = __webpack_public_path__ + "static/a-xx-031-art-9e448b17eb65148545ef8767d871bc6b.jpg";